import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Button } from '@scramble/ui';
import { useIsMobile } from '@scramble/hooks';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import s from './index.module.scss';

const id = MODAL_IDS.verification_bonus_info_modal;

export const VerificationBonusInfoModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

const Modal = () => {
  const { closeModal } = useModal();
  const isMobile = useIsMobile();
  const { t } = useTranslation('modal');

  const content = (
    <div className={s.modal}>
      <div className={s.header}>
        <div className={s.title}>
          {t('verification_bonus_info_modal.how_does_the_bonus_work')}
        </div>
      </div>
      <div className={s.content}>
        <div className={s.content_inner}>
          <div className={s.row}>
            <div className={s.question}>
              {t('verification_bonus_info_modal.what_is_the_bonus')}
            </div>
            <div className={classnames(s.answer, 'f-label')}>
              {t('verification_bonus_info_modal.after_verification_bonus')}
            </div>
          </div>
          <div className={s.row}>
            <div className={s.question}>
              {t('verification_bonus_info_modal.how_to_use_the_bonus')}
            </div>
            <div className={classnames(s.answer, 'f-label')}>
              {t('verification_bonus_info_modal.bonus_intended_exclusively')}
            </div>
          </div>
          <div className={s.row}>
            <div className={s.question}>
              {t('verification_bonus_info_modal.how_can_i_withdraw_the_bonus')}
            </div>
            <div className={classnames(s.answer, 'f-label')}>
              {t('verification_bonus_info_modal.withdraw_bonus_and_earnings')}
            </div>
          </div>
          <div className={s.row}>
            <div className={s.question}>
              {t('verification_bonus_info_modal.what_happens_if_not_invest')}
            </div>
            <div className={classnames(s.answer, 'f-label')}>
              {t('verification_bonus_info_modal.bonus_earnings_forfeited')}
            </div>
          </div>
          <div className={s.row}>
            <div className={s.question}>
              {t('verification_bonus_info_modal.can_i_withdraw_my_own_funds')}
            </div>
            <div className={classnames(s.answer, 'f-label')}>
              {t('verification_bonus_info_modal.withdraw_own_funds_anytime')}
            </div>
          </div>
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          size="lg"
          label={t('verification_bonus_info_modal.got_it')}
          onClick={() => closeModal(id)}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
